import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

function CTASection() {
  const [ref, isVisible] = useFadeIn();

  return (
    <section className="bg-[#f5f5f7] px-8 md:px-16 py-16 md:py-24">
      <div
        ref={ref}
        className={`fade-in-section ${isVisible ? 'is-visible' : ''} max-w-[1440px] mx-auto flex flex-col items-center text-center gap-6`}
      >

        <p className="text-[13px] text-[#86868b] tracking-widest uppercase font-medium">
          Our Mission
        </p>

        <h2 className="text-3xl md:text-4xl xl:text-[44px] xl:leading-[1.15] text-[#1d1d1f] leading-snug max-w-[920px]">
          <span className="md:block">Driving the transformation of medication</span>
          <span className="md:block">
            accessibility, affordability, and quality <span className="gradient-text">for all</span>.
          </span>
        </h2>

        <p className="text-lg text-[#6e6e73] leading-relaxed max-w-xl lg:max-w-none lg:whitespace-nowrap font-normal mt-2">
          Building a transparent, easily accessible, and affordable medication experience.
        </p>

      </div>
    </section>
  );
}

export default CTASection;
